import axios from "axios";
import qs from "qs";
// import { isWechat } from './utils';
/**
   *  101 用户没录入姓名等基础信息 调转到信息录入页
      102 离职员工，没使用权限
      103 人事部未授权，没使用权限
      104 登录失效 请重新发起授权登录
      105 微信授权失败，可能是code复用了
      154 供应商token失效
   */
const err101 = (code) => {
  if (code !== 101) return "next";
  if (window.location.pathname !== "/working-monitor/register") {
    window.alert('请先完成个人信息填写~'); // eslint-disable-line
    window.location.replace(`${process.env.VUE_APP_DEPLOY_URL}/register`);
  }
};
const err104105 = (code) => {
  if (code !== 104 && code !== 105) return "next";
  localStorage.clear();
  isWX ? window.location.replace(`${process.env.VUE_APP_DEPLOY_URL}/`) : window.location.replace(`${process.env.VUE_APP_DEPLOY_URL}/login`);// eslint-disable-line
};
const err154 = (code) => {
  if (code !== 154) return "next";
  localStorage.clear();
  window.location.replace(`${process.env.VUE_APP_DEPLOY_URL}/vendor/provider/login`);// eslint-disable-line
};
const err403 = (code) => {
  if (code !== 403) return "next";
  window.alert("权限不足, 请联系管理员");
  window.history.back();
};
const err400 = (code) => {
  if (code !== 400) return "next";
  // window.alert('code:400错误，参数错误！')
};
const err500 = (code) => {
  if (code !== 500) return "next";
  window.alert("code:500错误，请联系管理员！");
};
const errorHandlerChain = [err101, err104105, err154, err400, err403, err500];
const errorHandle = (error) => {
  for (let handler of errorHandlerChain) {
    const result = handler(error);
    if (result !== "next") break;
  }
};
let lang = localStorage.getItem("333f-locale-lang") || "zh_cn";
// const isWX = isWechat();
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

axios.interceptors.request.use((config) => {
  // debugger
  if (!config.headers.requestType || config.headers.requestType !== "noToken") {
    config.headers.token = localStorage.getItem("token") || "";
  } // eslint-disable-line
  config.headers.lang = localStorage.getItem("333f-locale-lang") || 'zh_cn'
  if (config.url.indexOf('/other') >= 0) {
    config.baseURL =
      "https://show.333f.com/holiday-activity-api/public" +
      config.url.replace('/other', "");
  }
  return config;
});
axios.interceptors.response.use((res) => {
  errorHandle(res.data.code);

  return res;
});

export const get = (url, params = {}, token = true, a) => {
  if (token) return axios.get(url, { params }).then((res) => res.data);
  return axios
    .get(url, { params, headers: { requestType: "noToken" } })
    .then((res) => res.data);
};
export const getFile = (url, params = {}, token = true, a) => {
  if (token)
    return axios
      .get(url, { params, responseType: "blob" })
      .then((res) => res.data);
  return axios
    .get(url, {
      params,
      headers: { requestType: "noToken", responseType: "blob" },
    })
    .then((res) => res.data);
};
export const post = (url, params = {}, token = true) => {
  if (token)
    return axios.post(url, qs.stringify(params)).then((res) => res.data);
  return axios
    .post(url, qs.stringify(params), { headers: { requestType: "noToken" } })
    .then((res) => res.data);
};
export const deletes = (url, params = {}) => {
  return axios.delete(url, qs.stringify(params)).then((res) => res.data);
};



// WEBPACK FOOTER //
// ./src/js/http.js